import React, { Fragment } from "react";
import { Route, Switch } from "react-router-dom";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";

import Creator from "../pages/Creator";
import Order from "../pages/Order";

import Navbar from "./Navbar";

import i18n from "../i18n";
import { LINKS } from "../routes";

// Source: https://codesandbox.io/s/j2nxmjywx5
const changeLanguage = lng => {
  i18n.changeLanguage(lng);
};

function Routes({ location, match }) {
  const { t } = useTranslation();
  const lang = i18n.language;
  const {
    params: { locale }
  } = match;

  if (lang != locale) {
    changeLanguage(locale);
  }

  return (
    <Fragment>
      <Navbar
        changeLanguage={changeLanguage}
        locale={locale}
        location={location}
      />
      <div className="fl w-100 pl4 pr4">
        <Switch>
          <Route
            exact
            path={`${match.url}/`}
            component={() => <Order locale={locale} />}
          />
          <Route
            path={`${match.url}${LINKS[locale].creator}`}
            component={() => <Creator locale={locale} />}
          />
        </Switch>
      </div>
    </Fragment>
  );
}

export default connect(
  state => ({
    location: state.router.location
  }),
  null
)(Routes);
